export default "__VITE_ASSET__q6HSGlhW__"